<template>
  <div class="myCurrency">
    <div class="title"><span>我的咖币</span></div>
    <dl class="cont">
        <dd>
            <div class="name">总余额</div>
            <div class="count">{{ data.totalPoint || 0 }}</div>
        </dd>
        <dd>
            <div class="name">可用余额</div>
            <div class="count">{{ data.surplusPoint || 0 }}</div>
        </dd>
        <dd>
            <div class="name">冻结余额</div>
            <div class="count">{{ data.frozePoint || 0 }}</div>
        </dd>
    </dl>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="收入明细" name="first">
            <el-table
                :data="list"
                border
                style="width: 100%"
                size="mini"
                align="center">
                <el-table-column
                prop="outOrderNo"
                label="外部订单号"
                width="180">
                </el-table-column>
                <el-table-column
                prop="point"
                label="交易积分数量"
                width="180">
                </el-table-column>
                <el-table-column
                prop="surplusPoint"
                label="剩余积分">
                </el-table-column>
                <el-table-column
                prop="type"
                label="记录类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 1" style="color:#67C23A;">收入</span>
                        <span v-else style="color:#F56C6C;">支出</span>
                    </template>
                </el-table-column>
                <el-table-column
                prop="body"
                label="交易描述">
                </el-table-column>
                <el-table-column
                prop="createTime"
                label="交易时间">
                </el-table-column>
            </el-table>
        </el-tab-pane>
        <el-tab-pane label="支出明细" name="second">
            <el-table
                :data="list"
                border
                style="width: 100%"
                size="mini">
                <el-table-column
                prop="outOrderNo"
                label="外部订单号"
                width="180">
                </el-table-column>
                <el-table-column
                prop="point"
                label="交易积分数量"
                width="180">
                </el-table-column>
                <el-table-column
                prop="surplusPoint"
                label="剩余积分">
                </el-table-column>
                <el-table-column
                prop="type"
                label="记录类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 1" style="color:#67C23A;">收入</span>
                        <span v-else style="color:#F56C6C;">支出</span>
                    </template>
                </el-table-column>
                <el-table-column
                prop="body"
                label="交易描述">
                </el-table-column>
                <el-table-column
                prop="createTime"
                label="交易时间">
                </el-table-column>
            </el-table>
        </el-tab-pane>
    </el-tabs>
    <div class="page" style="margin-top: 25px;">
        <el-pagination
            background
            layout="total,prev, pager, next"
            :page-size="this.size"
            :total="this.total"
            :current-page="this.page"
            @current-change="handleCurrentChange">
        </el-pagination>
    </div>
  </div>
</template>
<script>
import api from '../../../api'
import {listSearchMixin} from '../../../config/mixin'
export default {
  mixins: [listSearchMixin],
  name: 'myEvaluate',
  data () {
    return {
      evaluateList: [],
      page: 1,
      size:10,
      total: 0,
      flag: true,
      loading: false,
      data:{},
      list:[],
      recordType:1,
      activeName:'first'
    }
  },
  mounted () {
    this.getMyCurrency();
    this.currencyRecords(this.recordType);
  },
  methods: {
    // 获取我的咖币
    getMyCurrency () {
    //   const rLoading = this.openLoading()
      let self = this
      self.loading = true
      let params = {
          url: api.getCurrency,
          method: 'POST',
          data: {
          }
        }
        self.sendReq(params, (res) => {
          if (res.code === '200') {
              this.data = res.data;
              self.loading = false
          } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
        })
    },
    //咖币记录
    currencyRecords(recordType){
        let self = this
        self.loading = true
        let params = {
            url: api.checkCurrency + `?recordType${recordType}=&page=${self.page}&pageSize=10`,
            method: 'POST',
            data: {
            }
        }
        self.sendReq(params, (res) => {
            if (res.code === '200') {
                this.list.push(...res.data.list);
                this.total = res.data.total;
                self.loading = false
            } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
        })
    },
    //选项卡
    handleClick(value){
        let self = this;
        self.list = [];
        self.page = 1;
        self.recordType = Number(value.index)+1;
        this.currencyRecords(self.recordType);
    },
    //切换分页
    handleCurrentChange (val) {
      this.page = val;
      this.handleClick(this.recordType)
    }
  }
}
</script>
<style lang="scss" scoped>
.myCurrency{
    padding: 24px;
    overflow: hidden;
    .title{
        position: relative;
        display: flex;
        &::after{
            display: block;
            content:'';
            overflow: hidden;
            width: 100%;
            height: 1px;
            background: #ccc;
            position: absolute;
            left: 0px;
            bottom: 0px;
        }
        span{
            display: block;
            line-height: 50px;
            font-size: 20px;
            font-weight: bold;
            color: #333;
            position: relative;
            z-index: 3;
            &::after{
                display: block;
                content: "";
                overflow: hidden;
                background: #FF7800;
                height: 2px;
                width: 100%;
                position: absolute;
                left: 0px;
                bottom: 0px;
            }
        }
    }
    .cont{
        display: flex;
        padding: 80px 0px;
        dd{
            flex: 1 0 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
            &::after{
                display: block;
                content: "";
                position: absolute;
                right: 0px;
                top: 50%;
                transform: translateY(-50%);
                width: 1px;
                height: 100%;
                background: #efefef;
            }
            &:last-child::after{
                display: none;
            }
        }
        .name{
            font-size: 18px;
            color: #333;
            margin-bottom: 5px;
        }
        .count{
            font-size: 24px;
            color: #FF7800;
            font-weight: bold;
            overflow: hidden;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/currency/index.vue